import { render, staticRenderFns } from "./OrderCustomerCompleted.vue?vue&type=template&id=433de460&"
import script from "./OrderCustomerCompleted.vue?vue&type=script&lang=ts&"
export * from "./OrderCustomerCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports